import React from "react";

import ReimbursementRequestViewAll from "../../../containers/ReimbursementRequest/ReimbursementRequestViewAll";
import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";
import ICONS from "../../../assets/Icons";

const ReimburseRequestViewAllPopup = ({
  closeReimburseTxnDetailsModal,
  TxnHistoryid,
  TxnHistoryAccountName,
  categoryName,
  type,
  flow,
  popupCatName,
}) => {
  return (
    <div>
      <LargePopupRedirect
        headerTitle="Request history"
        headersubtext="All requests related to the reimbursement account are listed below."
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        headertextSize="font-md"
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={closeReimburseTxnDetailsModal}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
      >
        <ReimbursementRequestViewAll
          type={type}
          TxnHistoryid={TxnHistoryid}
          TxnHistoryAccountName={TxnHistoryAccountName}
          categoryName={categoryName}
          closeReimburseTxnDetailsModal={closeReimburseTxnDetailsModal}
          flow={flow}
          popupCatName={popupCatName}
        />
      </LargePopupRedirect>
    </div>
  );
};

export default ReimburseRequestViewAllPopup;
